module.exports = __webpack_public_path__ + "static/reinventing-nature_detail1-2012-59aaca850233eceda328df329cf570d0.jpg";